












































import { Vue, Component, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { ISortData } from '@/interface/GamesManagement';

@Component({
  components: {
    draggable,
  },
})
export default class GamesManagementBody extends Vue {
  @Prop() readonly data!: Array<ISortData>;

  @Prop() readonly isEditSort!: boolean;

  @Prop() readonly sortData!: Function

  newSortData() {
    this.sortData(this.data);
  }

  getNetWin(item: ISortData): number {
    return item.riskConfig && item.riskConfig.netWin ? item.riskConfig.netWin : 0;
  }

  getMultiplier(item: ISortData): number {
    return item.riskConfig && item.riskConfig.multiplier ? item.riskConfig.multiplier : 0;
  }

  updateNetWin(index: number, value: string) {
    const numericValue = parseFloat(value) || 0;
    if (!this.data[index].riskConfig) {
      this.data[index].riskConfig = { netWin: 0, multiplier: 0 };
    }
    this.data[index].riskConfig.netWin = numericValue;
    this.sortData(this.data);
  }

  updateMultiplier(index: number, value: string) {
    const numericValue = parseFloat(value) || 0;
    if (!this.data[index].riskConfig) {
      this.data[index].riskConfig = { netWin: 0, multiplier: 0 };
    }
    this.data[index].riskConfig.multiplier = numericValue;
    this.sortData(this.data);
  }
}
